import { render, staticRenderFns } from "./bzrHis.vue?vue&type=template&id=67c9299e&scoped=true"
import script from "./bzrHis.vue?vue&type=script&lang=js"
export * from "./bzrHis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c9299e",
  null
  
)

export default component.exports